
import { Vue, Component, Prop } from 'vue-property-decorator';

// 必须使用@Component注解
@Component
export default class IndexVue extends Vue {

  // 跳转到上一页
  private async goHistory() {
    this.$router.go(-1);
  }
}
